import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Overlay from "web/react/components/overlay/overlay";
import ComparisonOption from "web/react/components/comparison-option/comparison-option";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";
import { BuyOptionPropType } from "web/types/buy-option";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import style from "./product-description-compare-prices.css";

function ProductDescriptionComparePrice(_ref) {
  var _classnames;

  var allSizesSorted = _ref.allSizesSorted,
      analyticsTitle = _ref.analyticsTitle,
      buyOptions = _ref.buyOptions,
      shouldDisplaySizes = _ref.shouldDisplaySizes,
      inlineVariant = _ref.inlineVariant,
      sortedBuyOptions = _ref.sortedBuyOptions,
      title = _ref.title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      comparePriceOpen = _useState2[0],
      setComparePriceOpen = _useState2[1];

  useEffect(function () {
    // Close modal on URL change
    window.addEventListener("popstate", closeModal);
    return function () {
      window.removeEventListener("popstate", closeModal);
    };
  }, []);

  function onClick() {
    analytics.event(analyticsTitle ? analyticsTitle : "compare-prices", "clicked", "open");
    openModal();
  }

  function openModal() {
    setComparePriceOpen(true);
  }

  function closeModal() {
    setComparePriceOpen(false);
  }

  var comparePriceText = gettext("in_stock_product.compare_prices_in_stores_link", {
    store_count: sortedBuyOptions.length
  });
  var comparePriceTextTest = gettext("in_stock_product.compare_prices_text_link");
  return React.createElement(React.Fragment, null, React.createElement("button", {
    className: classnames((_classnames = {}, _defineProperty(_classnames, style.comparePricesTest, inlineVariant), _defineProperty(_classnames, style.comparePrices, !inlineVariant), _classnames)),
    onClick: onClick,
    type: "button"
  }, React.createElement("span", {
    className: classnames(style.comparePricesText, _defineProperty({}, style.comparePricesTestText, !inlineVariant))
  }, title ? title : inlineVariant ? comparePriceTextTest : comparePriceText), React.createElement(SVGIcon, {
    className: style.icon,
    name: "round-chevron"
  })), React.createElement(Overlay, {
    isOpen: comparePriceOpen,
    title: gettext("in_stock_product.store_comparison_title"),
    onRequestClose: closeModal
  }, sortedBuyOptions.map(function (linkId, index) {
    var buyOption = buyOptions[linkId];
    var defaultSize = buyOption.sizes[buyOption.default_size];
    var shippingOptions = null;

    if (defaultSize.shipping_info) {
      shippingOptions = defaultSize.shipping_info;
    }

    var freeReturn = false;

    if (defaultSize.returns) {
      freeReturn = defaultSize.returns.is_free;
    }

    return React.createElement(ComparisonOption, {
      key: linkId,
      allSizesSorted: allSizesSorted,
      buyOptionSizes: buyOption.sizes,
      shouldDisplaySizes: shouldDisplaySizes,
      className: style.priceBox,
      formattedPrice: defaultSize.formatted_price,
      freeReturn: freeReturn,
      isAlternativeOption: index > 0,
      isInStock: buyOption.in_stock,
      leadUrl: defaultSize.lead_url,
      onSale: defaultSize.is_on_sale,
      productId: buyOption.product_id,
      retailerName: buyOption.retailer_name,
      salePrice: defaultSize.formatted_sale_price,
      shippingOptions: shippingOptions
    });
  })));
}

ProductDescriptionComparePrice.propTypes = {
  allSizesSorted: PropTypes.array,
  analyticsTitle: PropTypes.string,
  buyOptions: PropTypes.objectOf(BuyOptionPropType).isRequired,
  shouldDisplaySizes: PropTypes.bool,
  sortedBuyOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  inlineVariant: PropTypes.bool,
  title: PropTypes.string
};
export default ProductDescriptionComparePrice;